export default __webpack_public_path__ + "static/media/cnn.7843b9da.svg";